import { TypographyComponent } from 'src/components/Typography'
import theme, { techTheme } from '../../styles/theme'

import styled, { css } from 'styled-components'

import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { FormControlLabel } from '@mui/material'

export const ContainerFlex = styled('form')(
  () => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 70%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const FormControl = styled(FormControlLabel)(
  () => css`
    display: flex;
    align-items: center;
    width: 100%;
  `
)

export const Typograph = styled(TypographyComponent)(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
    text-transform: uppercase;
  `
)

export const WhatsApp = styled(WhatsAppIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Email = styled(AlternateEmailIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const HelperText = styled('span')(
  () => css`
    font-size: 1rem;
  `
)

export const Info = styled('div')(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.small};
      background-color: ${techTheme.colors.primary.main20};
      color: ${theme.colors.base.blue};
      border-radius: ${theme.layout.borderRadius.medium};
      display: flex;
      align-items: center;
      padding: ${theme.layout.padding.small};
      gap: ${theme.layout.gap.small};
    }
  `
)
